import React from 'react';
import _ from 'lodash';
import { Redirect } from 'react-router-dom';
// import { LoadableWrapper } from '../components';
import {
  SEGMENTS,
  INSIGHT_SEGMENTS,
  SYSTEMSETTING_SEGMENTS,
  SEPARATION_APPROACH_KEY,
  INSIGHTS_ORDER_ARRAY,
  USER_ROLE_MODEL,
  projectRole,
  INTEGRATION_APPROACH_KEY,
  ORG_CHART_KEY,
  GANTT_CHART_KEY,
  ORG_CHART_TITLE,
  GANTT_CHART_TITLE,
  DEFALUT_PERMISSION_SECTION,
} from '@model';
import Projects from '@modules/projects';
import ProjectsList from '@modules/projects/projectsList';
import ProjectsForm from '@modules/projects/projectsForm';
import ProjectsDetail from '@modules/projects/projectDetail';
import ProjectSetting from '@modules/projects/projectSetting';
import ProjectsIframe from '@modules/projects/integrationHub/integrationInframePage';
import {
  CustomizedPowerBIModule,
  CustomizedIframeModule,
} from '@modules/customizedModule';
import { Analysis, AnalysisProtal } from '@modules/analysis';
import {
  InsightsRoot,
  Insights,
  ValueDriverManager,
  ValueDriver,
  IntegrationApproach,
  SeparationApproach,
  GuidingPrinciples as InsightsGuidingPrinciple,
} from '@modules/insights';
import { IntegrationManageModules } from '@modules/projects/integrationHub';
// import Privacy from '@modules/privacy';
import {
  SystemSetting,
  // NavigationTiles,
  ValueDrivers as SystemValueDriver,
  VisualizationWidget,
  // GuidingPrinciples,
  ManageWhiteList,
  UserGuideSetting,
  // GuidingPrinciplesSystemSetting,
  SystemModule,
  AiConfigSetting,
} from '@modules/systemSetting';
import { TicketList } from '@modules/ticket';
import Questionnaires from '@modules/questionnaires';
import QuestionContent from '@modules/questionnaires/questionContent';
import ReviewResponses from '@modules/questionnaires/reviewResponses';
import UserGuide from '@modules/userGuide';
import { HubModuleViewMode } from '@components';
import OperatingModel from '@modules/insights/OperatingModel';
import DealRationale from '@modules/insights/dealRationale';
import UserGuideShared from '@modules/userGuideShared';
import EmailLinkRedirect from '@modules/emailLinkRedirect';
import MaturityAssessment from '@modules/insights/maturityAssessment/maturityAssessmment';
import {
  getAnalysisIdentifier,
  getCustomizedModuleIdentifier,
} from '@utils/history';
import { getSessionStorage } from '@utils/windowUtil';
import { ErrorBackTo } from '@components/error';
import OrgChart from '@modules/insights/orgChart/orgChart';
import GanttChart from '@modules/insights/ganttChart/ganttChart';
import VisualWidget from '@modules/visualWidget';
import TextContainerModule from '@modules/textContainerModule/textContainerModule';
import MultiSectionModule from '@modules/multiSectionModule/multiSectionModule';
import ThemeTestPage from '@modules/themeTestPage/ThemeTestPage';
import { isHtmlModuleEnabled } from '@utils/htmlModuleConfig';

const htmlLinkRoute = {
  path: '/htmlLink',
  exact: true,
  main: ProjectsIframe,
  permission: {
    checkCustomizedModule: true,
    getIdentifier: getCustomizedModuleIdentifier,
  },
};

const redirectToProjectList = () => `/error?backTo=${ErrorBackTo.projectList}`;

const renderAnalysisRedirect = (target) => () => {
  const currentId = getSessionStorage('currentId');
  // const projectName = getSessionStorage('projectName');
  // const params = encodeURIComponent(
  //   `currentId=${currentId}&&projectName=${projectName}`,
  // );
  const params = new URLSearchParams();
  params.append('projectId', currentId);
  // params.append('projectName', projectName);
  return (
    <Redirect
      to={`/analysis/${
        target || Object.keys(SEGMENTS)[0]
      }?${params.toString()}`}
    />
  );
};
const routes = [
  {
    path: 'projects',
    label: 'projects',
    displayName: 'Project List',
    // main: LoadableWrapper(() => import('../modules/projects')),
    main: Projects,
    icon: 'icon-list-view-outline',

    routes: [
      {
        path: '/',
        exact: true,
        render: () => <Redirect to="/projects/list" />,
      },
      {
        label: 'Project List',
        path: '/list',
        exact: true,
        // main: LoadableWrapper(() => import('../modules/projects/projectsList')),
        main: ProjectsList,
        permission: false, // falsy value indicate no need to check permission
      },
      {
        path: '/create',
        exact: true,
        render: () => <Redirect to="/projects/create/projectDetail" />,
        permission: {
          userRole: [USER_ROLE_MODEL.ADMIN, USER_ROLE_MODEL.INTERNAL],
          getRedirectPath: redirectToProjectList,
        },
      },
      {
        label: 'New Project',
        path: '/create/:step',
        exact: true,
        // main: LoadableWrapper(() => import('../modules/projects/projectsForm')),
        main: ProjectsForm,
        permission: {
          userRole: [USER_ROLE_MODEL.ADMIN, USER_ROLE_MODEL.INTERNAL],
          getRedirectPath: redirectToProjectList,
        },
      },
      {
        // label: 'M&A Gateway',
        path: '/link',
        exact: true,
        // main: LoadableWrapper(() =>
        //   import('../modules/projects/projectDetail'),
        // ),
        main: ProjectsIframe,
        permission: {
          checkCustomizedModule: true,
          getIdentifier: getCustomizedModuleIdentifier,
        },
      },
      // {
      //   // label: 'M&A Gateway',
      //   path: '/imageLink/:moduleValue',
      //   exact: true,
      //   main: ProjectsIframe,
      // },
      {
        // label: 'M&A Gateway',
        path: '/imageLink',
        exact: true,
        main: ProjectsIframe,
        permission: {
          checkCustomizedModule: true,
          getIdentifier: getCustomizedModuleIdentifier,
        },
      },
      {
        // label: 'M&A Gateway',
        path: '/pdfLink',
        exact: true,
        main: ProjectsIframe,
        permission: {
          checkCustomizedModule: true,
          getIdentifier: getCustomizedModuleIdentifier,
        },
      },
      ...(isHtmlModuleEnabled() ? [htmlLinkRoute] : []),
      {
        path: '/widgetLink',
        exact: true,
        main: VisualWidget,
      },
      {
        path: '/multiSectionLink',
        exact: true,
        main: MultiSectionModule,
      },
      {
        // manage tiles page work with concurrent lock and should not be visited directly
        label: 'Manage Tiles',
        path: '/manageTiles',
        exact: true,
        // main: LoadableWrapper(() =>
        //   import('../modules/projects/projectDetail'),
        // ),
        main: IntegrationManageModules,
      },
      {
        // label: 'powerBI',
        path: '/powerBI',
        exact: true,

        // main: LoadableWrapper(() =>
        //   import('../modules/projects/projectDetail'),
        // ),
        main: HubModuleViewMode,
        permission: {
          checkCustomizedModule: true,
          getIdentifier: getCustomizedModuleIdentifier,
        },
      },
      {
        label: 'Settings',
        path: '/setting',
        exact: true,
        // main: LoadableWrapper(() =>
        //   import('../modules/projects/projectDetail'),
        // ),
        main: ProjectSetting,
        permission: {
          userRole: [USER_ROLE_MODEL.ADMIN, USER_ROLE_MODEL.INTERNAL],
          projectRole: [projectRole.Contributor],
        },
      },
    ],
  },
  {
    showWhenHasId: true,
    label: 'Project Home',
    path: 'project-detail/:id',
    // main: LoadableWrapper(() => import('../modules/projects')),
    main: ProjectsDetail,
    icon: 'icon-home-outline',
  },
  {
    showWhenHasId: true,
    path: 'questionnaires',
    label: 'questionnaire',
    icon: 'icon-help-question-outline',
    // main: LoadableWrapper(() => import('../modules/teams')),
    main: Questionnaires,
    permission: {
      checkCustomizedModule: true,
      identifier: 'complexity',
    },
    routes: [
      {
        path: '/',
        exact: true,
        render: () => <Redirect to="/questionnaires/welcome" />,
      },
      {
        path: '/review-responses',
        exact: true,
        main: ReviewResponses,
        permission: {
          userRole: [USER_ROLE_MODEL.ADMIN, USER_ROLE_MODEL.INTERNAL],
          projectRole: [projectRole.Contributor],
        },
      },
      {
        path: '/:section',
        exact: true,
        main: QuestionContent,
        permission: {
          userRole: [USER_ROLE_MODEL.ADMIN, USER_ROLE_MODEL.INTERNAL],
          projectRole: [projectRole.Contributor],
        },
      },
      {
        path: '/:section/:sequence',
        exact: true,
        main: QuestionContent,
        permission: {
          userRole: [USER_ROLE_MODEL.ADMIN, USER_ROLE_MODEL.INTERNAL],
          projectRole: [projectRole.Contributor],
        },
      },
    ],
  },
  {
    showWhenHasId: true,
    path: 'analysis',
    label: 'Analysis',
    icon: 'icon-bar-chart-outline',
    main: Analysis,
    // main: LoadableWrapper(() => import('../modules/analysis')),
    routes: [
      {
        path: '/',
        exact: true,
        render: renderAnalysisRedirect(),
      },
      {
        path: '/:segmentId',
        exact: true,
        main: AnalysisProtal,
        permission: {
          checkCustomizedModule: true,
          getIdentifier: getAnalysisIdentifier,
        },
      },
    ],
  },
  {
    showWhenHasId: true,
    path: 'insights',
    label: 'Insights',
    icon: 'icon-spark-line-outline',
    // main: LoadableWrapper(() => import('../modules/insights')),
    main: InsightsRoot,
    routes: [
      {
        path: '/',
        exact: true,
        render: () => (
          <Redirect
            to={`/insights/${INSIGHT_SEGMENTS['integration-approach']}`}
          />
        ),
      },
      {
        path: `/${INSIGHT_SEGMENTS['operating-model']}`,
        label: 'Operating Model',
        exact: true,
        main: OperatingModel,
      },
      {
        path: `/${INSIGHT_SEGMENTS.dealrationale}`,
        label: 'Deal Rationale',
        exact: true,
        main: DealRationale,
        permission: {
          checkCustomizedModule: true,
          identifier: 'dealrationale',
        },
      },
      {
        path: `/${INSIGHT_SEGMENTS.insights}`,
        label: 'Insights',
        exact: true,
        main: Insights,
        permission: {
          checkCustomizedModule: true,
          identifier: 'insights',
        },
      },
      {
        path: `/${INSIGHT_SEGMENTS.guidingPrinciples}`,
        label: 'Integration Guiding Principles',
        exact: true,
        main: InsightsGuidingPrinciple,
        permission: {
          checkCustomizedModule: true,
          identifier: 'guidingPrinciples',
        },
      },
      {
        path: `/${INSIGHT_SEGMENTS['guidingPrinciples-divestitures']}`,
        label: 'Divestiture Guiding Principles',
        exact: true,
        main: InsightsGuidingPrinciple,
        permission: {
          checkCustomizedModule: true,
          identifier: 'guidingPrinciples-divestitures',
        },
      },
      {
        path: `/${INSIGHT_SEGMENTS['value-driver']}`,
        label: 'Value Drivers',
        exact: true,
        main: ValueDriver,
        permission: {
          checkCustomizedModule: true,
          identifier: 'value-driver',
        },
      },
      {
        path: `/${INSIGHT_SEGMENTS.maturityAssessment}`,
        label: 'Readiness Assessment',
        exact: true,
        main: MaturityAssessment,
        permission: {
          checkCustomizedModule: true,
          identifier: 'maturityAssessment',
        },
      },
      {
        path: `/manager`,
        label: 'Manage Value Drivers',
        exact: true,
        main: ValueDriverManager,
        permission: {
          userRole: [USER_ROLE_MODEL.ADMIN, USER_ROLE_MODEL.INTERNAL],
          projectRole: [projectRole.Contributor],
          redirectTo: (projectId) =>
            `/insights/value-driver?projectId=${projectId}`,
        },
      },
      {
        path: `/${INSIGHT_SEGMENTS['integration-approach']}`,
        label: 'Integration Approach',
        exact: true,
        main: IntegrationApproach,
        permission: {
          checkCustomizedModule: true,
          identifier: INTEGRATION_APPROACH_KEY,
        },
      },
      {
        path: `/${INSIGHT_SEGMENTS[SEPARATION_APPROACH_KEY]}`,
        label: 'Separation Approach',
        exact: true,
        main: SeparationApproach,
        permission: {
          checkCustomizedModule: true,
          identifier: SEPARATION_APPROACH_KEY,
        },
      },
      {
        path: `/${INSIGHT_SEGMENTS[ORG_CHART_KEY]}`,
        label: ORG_CHART_TITLE,
        exact: true,
        main: OrgChart,
        permission: {
          checkCustomizedModule: true,
          identifier: ORG_CHART_KEY,
        },
      },
      {
        path: `/${INSIGHT_SEGMENTS[GANTT_CHART_KEY]}`,
        label: GANTT_CHART_TITLE,
        exact: true,
        main: GanttChart,
        permission: {
          checkCustomizedModule: true,
          identifier: GANTT_CHART_KEY,
        },
      },
    ],
  },
  {
    label: 'powerBI',
    path: 'powerBI',
    exact: true,
    main: CustomizedPowerBIModule,
    permission: {
      checkCustomizedModule: true,
      getIdentifier: getCustomizedModuleIdentifier,
    },
  },
  {
    label: 'modulePage',
    path: 'link',
    exact: true,
    // main: LoadableWrapper(() =>
    //   import('../modules/projects/projectDetail'),
    // ),
    main: CustomizedIframeModule,
    permission: {
      checkCustomizedModule: true,
      getIdentifier: getCustomizedModuleIdentifier,
    },
  },
  {
    label: 'textContainer',
    path: 'textContainer',
    exact: true,
    // main: LoadableWrapper(() =>
    //   import('../modules/projects/projectDetail'),
    // ),
    main: TextContainerModule,
    permission: {
      checkCustomizedModule: true,
      getIdentifier: getCustomizedModuleIdentifier,
    },
  },

  // {
  //   path: 'privacy',
  //   label: 'Privacy',
  //   hideOnNav: true,
  //   main: Privacy,
  // },
  {
    path: 'settings',
    label: 'System Settings',
    hideOnNav: true,
    main: SystemSetting,
    permission: {
      userRole: [USER_ROLE_MODEL.ADMIN],
      getRedirectPath: redirectToProjectList,
    },
    routes: [
      // {
      //   path: `/${SYSTEMSETTING_SEGMENTS.navigation}`,
      //   label: 'Navigation Tiles Template',
      //   exact: true,
      //   main: NavigationTiles,
      // },
      {
        path: `/${SYSTEMSETTING_SEGMENTS.valuedriver}`,
        label: 'Value Drivers Template',
        exact: true,
        main: SystemValueDriver,
      },
      {
        path: `/${SYSTEMSETTING_SEGMENTS.visualizationwidget}`,
        label: 'Manage Visualization Widget',
        exact: true,
        main: VisualizationWidget,
      },
      {
        path: `/${SYSTEMSETTING_SEGMENTS.multiSectionModule}`,
        label: 'MultiSectionModule',
        exact: true,
        main: MultiSectionModule,
      },
      // {
      //   path: `/${SYSTEMSETTING_SEGMENTS.insights}`,
      //   label: 'Guiding Principles Template',
      //   exact: true,
      //   // main: GuidingPrinciples,
      //   main: GuidingPrinciplesSystemSetting,
      // },
      {
        path: `/${SYSTEMSETTING_SEGMENTS.whitelist}`,
        label: 'Manage White List',
        exact: true,
        main: ManageWhiteList,
      },
      {
        path: `/${SYSTEMSETTING_SEGMENTS.userGuide}`,
        label: 'User Guide Setting',
        exact: true,
        main: UserGuideSetting,
      },
      {
        path: `/${SYSTEMSETTING_SEGMENTS.systemModule}`,
        label: 'Project Instance',
        exact: true,
        main: SystemModule,
      },
      {
        path: `/${SYSTEMSETTING_SEGMENTS.aiConfig}`,
        label: 'AI config',
        exact: true,
        main: AiConfigSetting,
      },
    ],
  },
  {
    path: 'guide',
    label: 'User Guide',
    hideOnNav: true,
    main: UserGuide,
    exact: true,
    permission: {
      userRole: [USER_ROLE_MODEL.INTERNAL],
      getRedirectPath: redirectToProjectList,
    },
  },
  {
    path: 'guide-shared',
    label: 'User Guide Shared',
    hideOnNav: true,
    main: UserGuideShared,
    exact: true,
    permission: {
      userRole: [USER_ROLE_MODEL.INTERNAL],
      getRedirectPath: redirectToProjectList,
    },
  },
  {
    path: 'issue-list',
    label: 'Issue List',
    hideOnNav: true,
    main: TicketList,
    permission: {
      userRole: [USER_ROLE_MODEL.ADMIN],
      getRedirectPath: redirectToProjectList,
    },
  },
  {
    path: 'email-link-redirect',
    // label: 'Email Link Redirect',
    hideOnNav: true,
    main: EmailLinkRedirect,
  },
  {
    path: 'theme-test',
    hideOnNav: true,
    exact: true,
    main: ThemeTestPage,
    permission: false,
  },
];

const enhanceAnalysisRoute = (
  routes,
  accessibleModuleList,
  customizedModules,
) => {
  // const {
  //   analysisPermission: analysisPermRaw,
  //   insightPermission,
  //   questionnairePermission,
  // } = sectionsPermission;

  // const analysisPermission = [
  //   // ...deepCopy(accessibleModuleList).filter((e) =>
  //   //   INSIGHTS_ORDER_ARRAY.includes(e),
  //   // ),
  //   // ...deepCopy(analysisPermRaw).filter(
  //   //   (e) => !INSIGHTS_ORDER_ARRAY.includes(e),
  //   // ),
  // ];

  const analysisPermission = Object.keys(SEGMENTS).filter((i) =>
    accessibleModuleList?.includes(i),
  );
  const insightPermission = INSIGHTS_ORDER_ARRAY.filter((i) =>
    accessibleModuleList?.includes(i),
  );
  const firstAnalysisSubmodule = customizedModules
    ?.find((i) => i.value === DEFALUT_PERMISSION_SECTION.ANALYSIS)
    ?.originPermissions?.find((i) => accessibleModuleList?.includes(i.value));
  const firstInsightsSubmodule = customizedModules
    ?.find((i) => i.value === DEFALUT_PERMISSION_SECTION.INSIGHT)
    ?.originPermissions?.find((i) => accessibleModuleList?.includes(i.value));

  const finalRoutes = routes;
  // if (analysisPermission.length === 0) {
  //   finalRoutes = finalRoutes.filter((route) => route.path !== 'analysis');
  // }
  // if (insightPermission.length === 0) {
  //   finalRoutes = finalRoutes.filter((route) => route.path !== 'insights');
  // }
  // if (questionnairePermission.length === 0 && isClient) {
  //   finalRoutes = finalRoutes.filter(
  //     (route) => route.path !== 'questionnaires',
  //   );
  // }

  if (analysisPermission.length !== 0) {
    finalRoutes.forEach((route) => {
      if (route.path === 'analysis') {
        route.routes[0].render = renderAnalysisRedirect(
          firstAnalysisSubmodule?.value || analysisPermission[0],
        );
      }
    });
  }
  if (insightPermission.length !== 0) {
    finalRoutes.forEach((route) => {
      if (route.path === 'insights') {
        route.routes[0].render = () => (
          <Redirect
            to={`/insights/${
              firstInsightsSubmodule?.value || insightPermission[0]
            }`}
          />
        );
      }
    });
  }
  if (accessibleModuleList?.includes('complexity')) {
    finalRoutes.forEach((route) => {
      if (route.path === 'questionnaires') {
        // debugger;
        route.routes[0].render = () => (
          <Redirect to="/questionnaires/welcome" />
        );
      }
    });
  }

  return finalRoutes;
};

function getRoutes({
  isClient,
  // sectionsPermission,
  singleCompanyInstance,
  // internalSectionsPermission,
  accessibleModuleList,
  customizedModules,
}) {
  if (!isClient) {
    let finalRoutes = routes;
    if (singleCompanyInstance === 'Divestiture') {
      finalRoutes = finalRoutes.filter(
        (route) => route.path !== 'questionnaires',
      );
    }

    return enhanceAnalysisRoute(
      finalRoutes,
      accessibleModuleList,
      customizedModules,
    );
  }

  return enhanceAnalysisRoute(routes, accessibleModuleList, customizedModules);
}

function getBreadItems(data, root = '/') {
  data.forEach((item) => {
    const { path: _path, routes, type } = item;
    const customizedModuleTypes = [
      'powerbiModule',
      'imageModule',
      'regular',
      'textContainer',
      'multiSection',
      'widget',
      'pdf',
      ...(isHtmlModuleEnabled() ? ['html'] : []),
    ];
    const isCustomizedModule = customizedModuleTypes.includes(type);
    const path = !isCustomizedModule ? (root + _path).split('/:')[0] : item.to;
    const breadcrumbName = !isCustomizedModule ? item.label : item.displayName;

    if (!breadcrumbName) {
      return;
    }
    const result = {
      path,
      breadcrumbName,
      isCustomizedModule,
    };
    this.breadCrumbMap.push(result);
    if (Array.isArray(routes) && routes.length > 0) {
      getBreadItems.call({ breadCrumbMap: this.breadCrumbMap }, routes, path);
    }
  });
}

function getBreadData(newRoutes) {
  const breadCrumbMap = [];

  getBreadItems.call(
    { breadCrumbMap },
    // newRoutes || routes,
    Array.prototype.concat(
      [],
      newRoutes || [],
      routes.filter((e) => e.hideOnNav),
    ),
  );

  breadCrumbMap.unshift({
    path: '/',
    breadcrumbName: 'Gateway',
  });

  return _.compact(breadCrumbMap);
}

const ANALYSIS_BREADCRUMB_PREFIX = `/${
  routes.find((route) => route.label === 'analysis')?.path || 'analysis'
}/`;

const analysisSegRoutes = Object.keys(SEGMENTS).map((segKey) => ({
  path: `${ANALYSIS_BREADCRUMB_PREFIX}${segKey}`,
  breadcrumbName: SEGMENTS[segKey],
}));

const analysisRouteWhiteList = analysisSegRoutes.map((r) => r.path);

const breadCrumbMap = (newRoute) => getBreadData(newRoute);
// .concat(analysisSegRoutes);

export {
  routes,
  getRoutes,
  breadCrumbMap,
  analysisRouteWhiteList,
  ANALYSIS_BREADCRUMB_PREFIX,
};
